import { createGlobalStyle } from "styled-components";

export const GlobalStyle = createGlobalStyle`
html,   
body,
#root,
* {
    padding: 0;
    margin: 0;
    box-sizing: border-box;
    width: 100%;
   

}



ul,li{
    list-style: none;
}
`;
